class ProductCarouselTabs extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.tabFocus = 0
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabClick = this.handleTabClick.bind(this)
    this.handleArrowPress = this.handleArrowPress.bind(this)

    this.els.tab.elements.forEach((tabEl) => {
      tabEl.addEventListener('click', this.handleTabClick.bind(this))
    })

    this.els.tablist.element.addEventListener(
      'keydown',
      this.handleArrowPress.bind(this),
    )
  }

  handleTabClick (event) {
    const clickedTabEl = event.target.closest(this.els.tab.selector)

    if (!clickedTabEl) return

    this.els.tab.elements.forEach((tabEl) => {
      tabEl.setAttribute('aria-selected', tabEl === clickedTabEl)
    })

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.id !== clickedTabEl.getAttribute('aria-controls'),
      )
    })

    const title = clickedTabEl.dataset.title
    this.els.title.element.textContent = title

    document.dispatchEvent(new CustomEvent('tabChanged'))
  }

  handleArrowPress (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return

    this.els.tab.elements[this.tabFocus].setAttribute('tabindex', -1)

    if (event.key === 'ArrowRight') {
      this.tabFocus++
      // If we're at the end, go to the start
      if (this.tabFocus >= this.els.tab.elements.length) {
        this.tabFocus = 0
      }
      // Move left
    } else if (event.key === 'ArrowLeft') {
      this.tabFocus--
      // If we're at the start, move to the end
      if (this.tabFocus < 0) {
        this.tabFocus = this.els.tab.elements.length - 1
      }
    }

    this.els.tab.elements[this.tabFocus].setAttribute('tabindex', 0)
    this.els.tab.elements[this.tabFocus].focus()
  }
}

if (!customElements.get('product-carousel-tabs')) {
  customElements.define('product-carousel-tabs', ProductCarouselTabs)
}
